module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand12-dd4486c56abfea77778a790186f9a82f.jpg";